import { useRef } from "react";
import { track } from "../lib/usageTracker";

/**
 * #1594 — "the person opened this Settings card" for a card that has no fold to open.
 * The first activation inside it (a click, or Enter or Space on a control) sends one `settings.fold_open` with the card's item
 * word (from the closed list), once per mount. It draws nothing of its own: `display:
 * contents` leaves the card's box exactly where it was. Nothing the person typed or chose
 * inside the card is read.
 */
export default function UsageFirstTouch({ item, children }) {
  const sent = useRef(false);
  const touch = () => {
    if (sent.current) return;
    sent.current = true;
    track("settings.fold_open", { item });
  };
  // A finger landing may turn into a scroll and Tab may only pass by: neither counts.
  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") touch();
  };
  return (
    <div style={{ display: "contents" }} onClickCapture={touch} onKeyDownCapture={onKey}>
      {children}
    </div>
  );
}
